import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteModel } from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { AlertService, Constants } from 'src/app/shared/index';

@Component({
  selector: 'app-add-building',
  templateUrl: './add-building.component.html',
  styleUrls: ['./add-building.component.scss']
})
export class AddBuildingComponent implements OnInit {
  formBuildingDetails: FormGroup;
  formLinkUtilityToBuilding: FormGroup;
  formLinkLoad: FormGroup;
  // Common
  sites: any;
  siteId: string;
  siteModel: SiteModel;
  utilityList: any;
  buildingList: any;
  loadsList: any;
  sensors: any;
  public filteredLoads: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onLoadDestroy = new Subject<void>();
  loadSelect: any;
  loadsDetails: any;
  constructor(
    private fb: FormBuilder,
    public siteStepperService: SiteStepperService,
    public siteService: SiteService,
    private alertService: AlertService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.siteService.getAllSites().subscribe((sites) => {
      this.sites = sites;
    });
    this.sensors = new Array();
    this.createForm();
  }
  public onSiteChange = () => {
    if (
      !this.commonService.isNullOrUndefined(this.siteId) &&
      this.siteId !== ''
    ) {
      this.getBuildingBySiteId(this.siteId);
      this.getLoadsBySiteId(this.siteId);
    }
  };

  getBuildingBySiteId(siteId) {
    this.siteService.getBuildingBySiteId(siteId).subscribe((resp: any) => {
      this.buildingList = resp;
    });
  }

  getLoadsBySiteId(siteId) {
    const hydLoad = {
      siteID: this.siteId,
      subType: 'Hydraulic Unit',
      type: 'Turning'
    };
    const genericLoad = {
      siteID: this.siteId,
      subType: 'Generic Load',
      type: 'Turning'
    };
    const areaSpecificSensorLoad = {
      siteID: this.siteId,
      type: 'GenericSensorLoad'
    };
    const siteLevelSensors = {
      siteID: this.siteId,
      type: 'SiteLevel_Sensors'
    };

    this.siteService
      .getNonHydraulicLoadsBySiteId(this.siteId)
      .subscribe((nonHydData) => {
        for (let i = 0; i < nonHydData.length; i++) {
          const load = nonHydData[i];
          nonHydData[i].paramArr = this.buildLoadParams(load, true);
        }
        this.loadsList = nonHydData;
        forkJoin(
          this.siteService.getLoadsBasedOnTypeAndSubType(hydLoad),
          this.siteService.getLoadsBasedOnTypeAndSubType(genericLoad),
          this.siteService.getLoadsBasedOnTypeAndSubType(
            areaSpecificSensorLoad
          ),
          this.siteService.getLoadsBasedOnTypeAndSubType(siteLevelSensors)
        ).subscribe(
          ([
            hydData,
            genericLoadData,
            areaSpecificSensorLoadData,
            siteLevelSensorsData
          ]) => {
            // Get all hydraulic loads of the site
            for (let i = 0; i < hydData.length; i++) {
              if (hydData[i].hasEnergyMeter === 'YES') {
                hydData[i].paramArr = this.buildLoadParams(hydData[i], true);
              } else {
                hydData[i].paramArr = [];
              }
              hydData[i].digitalIOMap = {};
              this.AddParamForHydLoads(hydData[i]);
              this.loadsList.push(hydData[i]);
            }
            // Get all Generic loads of the site
            for (let i = 0; i < genericLoadData.length; i++) {
              if (genericLoadData[i].hasEnergyMeter === 'YES') {
                genericLoadData[i].paramArr = this.buildLoadParams(
                  genericLoad[i],
                  true
                );
              } else {
                genericLoadData[i].paramArr = [];
              }
              genericLoadData[i].digitalIOMap = {};
              this.AddParamForHydLoads(genericLoadData[i]);
              this.loadsList.push(genericLoadData[i]);
            }
            // Get all Area Specific Sensor loads of the site
            for (let i = 0; i < areaSpecificSensorLoadData.length; i++) {
              if (areaSpecificSensorLoadData[i].hasEnergyMeter === 'YES') {
                areaSpecificSensorLoadData[i].paramArr = this.buildLoadParams(
                  areaSpecificSensorLoadData[i],
                  true
                );
              } else {
                areaSpecificSensorLoadData[i].paramArr = [];
              }
              areaSpecificSensorLoadData[i].digitalIOMap = {};
              this.AddParamForHydLoads(areaSpecificSensorLoadData[i]);
              this.loadsList.push(areaSpecificSensorLoadData[i]);
            }
            // Get Site Level Sensors
            for (let i = 0; i < siteLevelSensorsData.length; i++) {
              if (siteLevelSensorsData[i].hasEnergyMeter === 'YES') {
                // Check later
                // siteLevelSensorsData[i].paramArr = this.commonService.buildLoadParams(areaSpecificSensorLoad[i], true);
                siteLevelSensorsData[i].paramArr = this.buildLoadParams(
                  siteLevelSensorsData[i],
                  true
                );
              } else {
                siteLevelSensorsData[i].paramArr = [];
              }
              siteLevelSensorsData[i].digitalIOMap = {};
              this.AddParamForHydLoads(siteLevelSensorsData[i]);
              this.loadsList.push(siteLevelSensorsData[i]);
            }
            this.initFilterLoad();
          }
        );
        //need to combine all into one
        this.initFilterLoad();
      });
  }

  createForm() {
    this.formBuildingDetails = this.fb.group({
      building: [''],
      siteId: [''],
      siteNameCtr: ['', [Validators.required]]
    });

    this.formLinkLoad = this.fb.group({
      building: ['', [Validators.required]],
      flowChannelID: [''],
      loadId: ['', [Validators.required]],
      siteId: [''],
      machineID: [''],
      loadSearchCtr: ['']
    });
  }

  currentLoads(loadItem) {
    console.log('in', loadItem);

    this.sensors = [];
    this.sensors = loadItem;
    if (loadItem && loadItem.machineID) {
      this.formLinkLoad.get('machineID').patchValue(loadItem.machineID);
    }

    if (loadItem && loadItem.type == 'GenericSensorLoad') {
      if (loadItem.paramArr.length > 0) {
        this.formLinkLoad.get('flowChannelID').enable();
        this.formLinkLoad
          .get('flowChannelID')
          .setValidators([Validators.required]);
        this.formLinkLoad.updateValueAndValidity();
      }
    } else {
      this.formLinkLoad.get('flowChannelID').setValidators(null);
      this.formLinkLoad.updateValueAndValidity();
      this.formLinkLoad.get('flowChannelID').disable();
    }
  }
  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formBuildingDetails.get(fieldName).hasError(errorCode);
  };
  public fieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formLinkUtilityToBuilding.get(fieldName).hasError(errorCode);
  };
  public hasError = (fieldName: string, errorCode: string): boolean => {
    return this.formLinkLoad.get(fieldName).hasError(errorCode);
  };

  //save building to site
  addBuilding() {
    let buildingData = this.formBuildingDetails.value;
    buildingData.siteId = this.siteId;

    this.siteService.createNewBuilding(buildingData).subscribe((res) => {
      if (res && res.data == 'Duplicate') {
        this.formBuildingDetails
          .get('building')
          .setErrors({ duplicated: true });
      } else {
        const error = this.formBuildingDetails
          .get('building')
          .getError('duplicated');
        if (error) {
          this.formBuildingDetails.get('building').setErrors(null);
        }
      }

      if (res && res.data == 'Success') {
        this.alertService.showSuccess('Building added successfully');
        this.getBuildingBySiteId(this.siteId);
      } else {
        this.alertService.showError('Error in adding building');
      }
    });

    this.formBuildingDetails.get('building').reset();
  }

  //Save loads details
  saveLinkingBuildingToLoad() {
    let data = this.formLinkLoad.value;
    data.loadId = data.loadId.loadId;
    data.siteId = this.siteId;
    data.siteId = this.siteId;
    data.flowChannelID =
      data && data.flowChannelID && data.flowChannelID.flowChannelID
        ? data.flowChannelID.flowChannelID
        : '';
    console.log(data);

    this.siteService.linkLoadToBuilding(data).subscribe((resp: any) => {
      if (resp && resp.data == 'Success') {
        this.alertService.showSuccess('Successfully linked load to building');
      } else {
        this.alertService.showError('Error in linking load to building');
      }
    });
    this.clearLinkLoadForm();
  }

  clearLinkLoadForm() {
    this.formLinkLoad.reset();
  }

  /**
   *Start loads lookup merge changes
   *
   * @private
   * @param {*} load
   * @param {boolean} forAlertConfig
   * @memberof BuildingUtilityComponent
   */
  private buildLoadParams = (load: any, forAlertConfig: boolean) => {
    let loadParamArr = [];
    let allElectricalParams = [];
    let otherParams = [];
    const paramTemperature = { text: 'Temperature', value: 'ambient_temp' };
    const paramPressure = { text: 'Pressure', value: 'ambient_pressure' };
    const paramCFMOutput = { text: 'CFM Output', value: 'CFM' };
    const fuelParam = { text: 'Fuel Consumption', value: 'fuelConsumption' };
    const irdSensorOutput = {
      text: 'Irradiation Sensor Output',
      value: 'IrradiationSensorOutput'
    };
    if (forAlertConfig === true) {
      allElectricalParams = [
        'On Duration',
        'Energy',
        'Real Time Power',
        'Voltage',
        'Current',
        'Power Factor' /* 'Shiftwaise Energy' */
      ];
    } else {
      allElectricalParams = [
        { text: 'current', value: 'current' },
        { text: 'currentA', value: 'currentA' },
        { text: 'currentB', value: 'currentB' },
        { text: 'currentC', value: 'currentC' },
        { text: 'voltage', value: 'voltage' },
        { text: 'voltageA', value: 'voltageA' },
        { text: 'voltageB', value: 'voltageB' },
        { text: 'voltageC', value: 'voltageC' },
        { text: 'powerfactor', value: 'powerfactor' },
        { text: 'powerfactorA', value: 'powerfactorA' },
        { text: 'powerfactorB', value: 'powerfactorB' },
        { text: 'powerfactorC', value: 'powerfactorC' },
        { text: 'realtimepower', value: 'realtimepower' },
        { text: 'realtimeenergy', value: 'realtimeenergy' },
        { text: 'registerenergy', value: 'registerenergy' },
        { text: 'Shiftwaise Energy', value: 'shiftwaiseenergy' }
      ];
    }
    otherParams = [
      paramTemperature,
      paramPressure,
      paramCFMOutput,
      fuelParam,
      irdSensorOutput
    ];
    if (load.parameters != null) {
      for (let j = 0; j < load.parameters.length; j++) {
        const param = load.parameters[j];
        switch (param.name) {
          case Constants.LOAD_PARAM.ALL_ELECTRICAL:
            const temp = allElectricalParams.map((x: any) => ({
              text: x,
              value: x
            }));
            // loadParamArr = loadParamArr.concat(allElectricalParams);
            loadParamArr = loadParamArr.concat(temp);
            break;
          case Constants.LOAD_PARAM.TEMPERATURE:
            loadParamArr.push(paramTemperature);
            loadParamArr = loadParamArr.concat(irdSensorOutput);
            break;
          case Constants.LOAD_PARAM.PRESSURE:
            loadParamArr.push(paramPressure);
            break;
          case Constants.LOAD_PARAM.FLOW_OUTPUT:
            loadParamArr.push(paramCFMOutput);
            loadParamArr.push(fuelParam);
            break;
          default:
            loadParamArr.push({ text: param.name, value: param.name });
        }
      }
    }
    if (loadParamArr.length === 0) {
      loadParamArr = allElectricalParams.concat(otherParams);
    }
    return loadParamArr;
  };

  private AddParamForHydLoads = (hydLoad: any) => {
    if (
      hydLoad.loadId !== null &&
      hydLoad.loadId !== undefined &&
      hydLoad.loadId !== ''
    ) {
      this.siteService
        .getLoadDetail(this.siteId, hydLoad.loadId)
        .subscribe((data) => {
          const flowChannels = [];
          if (data.inlets != null && data.inlets.length > 0) {
            for (let i = 0; i < data.inlets.length; i++) {
              flowChannels.push(data.inlets[i]);
            }
          }
          if (data.outlets != null && data.outlets.length > 0) {
            for (let i = 0; i < data.outlets.length; i++) {
              flowChannels.push(data.outlets[i]);
            }
          }

          // Build Hydraulic parameter
          for (let i = 0; i < flowChannels.length; i++) {
            hydLoad.paramArr.push(flowChannels[i]);

            // if sensor has digital class, build a map with data.extraInfo.LoadNodeData[i].info[j].name and it's corresponding digital output
            if (
              flowChannels[i].sensor != null &&
              flowChannels[i].sensor.digitalOutputMapping != null
            ) {
              // tslint:disable-next-line:max-line-length
              hydLoad.digitalIOMap[flowChannels[i].name] = [
                flowChannels[i].sensor.digitalOutputMapping.di_0,
                flowChannels[i].sensor.digitalOutputMapping.di_1
              ];
            }
          }
          //this.loads.push(hydLoad);
        });
    } else {
      if (hydLoad.type == 'SiteLevel_Sensors') {
        // Type and SiteID
        const siteLevelSensorParams = {
          siteID: hydLoad.siteID
        };
        this.siteService
          .getSiteLevelSensorDetails(siteLevelSensorParams)
          .subscribe((data) => {
            const flowChannels = [];
            if (data.inlets != null && data.inlets.length > 0) {
              for (let i = 0; i < data.inlets.length; i++) {
                flowChannels.push(data.inlets[i]);
              }
            }
            // Build Hydraulic parameter
            for (let i = 0; i < flowChannels.length; i++) {
              hydLoad.paramArr.push(flowChannels[i]);
              // tslint:disable-next-line:max-line-length
              // if sensor has digital class, build a map with data.extraInfo.LoadNodeData[i].info[j].name and it's corresponding digital output
              if (
                flowChannels[i].sensor != null &&
                flowChannels[i].sensor.digitalOutputMapping != null
              ) {
                // tslint:disable-next-line:max-line-length
                hydLoad.digitalIOMap[flowChannels[i].name] = [
                  flowChannels[i].sensor.digitalOutputMapping.di_0,
                  flowChannels[i].sensor.digitalOutputMapping.di_1
                ];
              }
            }
            //this.loads.push(hydLoad);
          });
      }
    }
    return hydLoad;
  };
  private initFilterLoad = () => {
    if (this.loadsList && this.loadsList.length > 0) {
      this.filteredLoads.next(this.loadsList.slice());
    }
  };
  private filterLoads = (control: AbstractControl) => {
    if (!this.loadsList) {
      return;
    }

    // get the search keyword
    let search = control.value;
    if (!search) {
      this.filteredLoads.next(this.loadsList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLoads.next(
      this.loadsList.filter(
        (load) => load.name.toLowerCase().indexOf(search) > -1
      )
    );
  };

  public compareFnLoad = (a: any, b: any) => {
    return a && b && a.rId === b.rId;
  };

  public changeLoadFilter = (event: any) => {
    const control = this.formLinkLoad;
    const temp = control.get('loadSearchCtr');
    temp.valueChanges.pipe(takeUntil(this._onLoadDestroy)).subscribe(() => {
      this.filterLoads(temp);
    });
  };
  //end loads lookup merge changes
  ngOnDestroy() {}
}
